"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7740],{

/***/ 67483:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ TagsStyle),
/* harmony export */   "z": () => (/* binding */ TagItem)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _ImageTag_ImageTag_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61770);


const TagsStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Tagsstyle__TagsStyle",
  componentId: "c49c5y-0"
})(["display:flex;overflow-x:scroll;gap:8px;flex-shrink:0;&::-webkit-scrollbar{display:none;}"]);
const TagItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Tagsstyle__TagItem",
  componentId: "c49c5y-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:0px 10px;cursor:pointer;flex-shrink:0;position:relative;display:flex;align-items:center;justify-content:center;height:33px;", " ", "{position:absolute;top:-5px;left:5px;}"], p => p.isSelected && `
background: var(--tm-accent-bg-color);
border: 1px solid var(--tm-accent-color);
border-radius: 6px;
`, _ImageTag_ImageTag_style__WEBPACK_IMPORTED_MODULE_1__/* .ImageTagStyle */ .L);

/***/ }),

/***/ 95062:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var _Tags_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67483);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);







const Tags = ({
  data,
  handleClickTab
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Tags_style__WEBPACK_IMPORTED_MODULE_2__/* .TagsStyle */ .E, {
    "data-test-id": "Tags-TagsStyle",
    children: data?.map(item => {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_Tags_style__WEBPACK_IMPORTED_MODULE_2__/* .TagItem */ .z, {
          isSelected: item.isSelected,
          onClick: handleClickTab ? () => handleClickTab(item.id) : () => {},
          "data-test-id": "Tags-TagItem",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
            color: item.isSelected ? "var(--tm-accent-color)" : _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText,
            fontSize: "xs",
            fontWeight: "black",
            "data-test-id": "Tags-SpanTag",
            children: item.name
          }), item.tagImg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ImageTag, {
            src: item.tagImg,
            width: "30px",
            height: "14px",
            "data-test-id": "Tags-ImageTag"
          })]
        }, item.id)
      });
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Tags);

/***/ }),

/***/ 88939:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);


const TestComponent = data => {
  console.log(data, "test component data");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    style: {
      height: "20px",
      width: "100%",
      background: "red"
    },
    "data-test-id": "TestComponent",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
      children: "Test Component"
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TestComponent);

/***/ }),

/***/ 95595:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TestimonialsSection_TestimonialsSection)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/index.ts + 7 modules
var icons = __webpack_require__(64204);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TestimonialsSection/Testimonials.style.ts


const TestimonialsSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__TestimonialsSectionWrapper",
  componentId: "sc-98byxy-0"
})(["background:", ";padding:40px 0 40px 40px;width:1200px;margin:0 auto;border-radius:16px;"], Global/* theme.whiteText */.rS.whiteText);
const TestimonialsHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__TestimonialsHeader",
  componentId: "sc-98byxy-1"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;padding-right:40px;"]);
const TestimonialsSectionTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Testimonialsstyle__TestimonialsSectionTitle",
  componentId: "sc-98byxy-2"
})(["font-weight:900;font-size:32px;color:", ";"], Global/* theme.blackText */.rS.blackText);
const CarouselButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__CarouselButton",
  componentId: "sc-98byxy-3"
})(["display:flex;border-radius:24px;padding:8px;box-shadow:0px 2px 7px 0px #0000003d;"]);
const ChevStateWrap = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Testimonialsstyle__ChevStateWrap",
  componentId: "sc-98byxy-4"
})(["cursor:pointer;border:none;background:none;&:disabled{opacity:0.5;cursor:default;}", ""], p => p.left ? `
transform:rotate(90deg);
` : `
transform:rotate(-90deg);
`);
const CarouselWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__CarouselWrapper",
  componentId: "sc-98byxy-5"
})(["position:relative;padding-right:40px;"]);
const CarouselContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__CarouselContent",
  componentId: "sc-98byxy-6"
})(["overflow:hidden;"]);
const CardsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__CardsContainer",
  componentId: "sc-98byxy-7"
})(["display:flex;gap:24px;transition:transform 0.5s ease-in-out;transform:translateX( -", "% );"], props => props.currentIndex * (100 / props.itemsPerView));
const TestimonialCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__TestimonialCard",
  componentId: "sc-98byxy-8"
})(["display:flex;position:relative;flex-direction:column;width:500px;border-radius:16px;padding:24px;flex-shrink:0;border:1px solid ", ";"], Global/* theme.lightSilver */.rS.lightSilver);
const CardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__CardHeader",
  componentId: "sc-98byxy-9"
})(["display:flex;justify-content:space-between;align-items:center;"]);
const BoughtFor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__BoughtFor",
  componentId: "sc-98byxy-10"
})(["display:flex;gap:8px;align-items:center;"]);
const BoughtForLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Testimonialsstyle__BoughtForLabel",
  componentId: "sc-98byxy-11"
})(["font-size:14px;color:#000;font-weight:400;"]);
const BoughtForCountry = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Testimonialsstyle__BoughtForCountry",
  componentId: "sc-98byxy-12"
})(["font-size:14px;color:#008cff;font-weight:600;"]);
const StarsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__StarsContainer",
  componentId: "sc-98byxy-13"
})(["display:flex;gap:4px;"]);
const Star = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Testimonialsstyle__Star",
  componentId: "sc-98byxy-14"
})(["color:", ";font-size:20px;"], props => props.filled ? "#FFA500" : "#E0E0E0");
const TestimonialContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__TestimonialContent",
  componentId: "sc-98byxy-15"
})(["color:", ";margin-bottom:16px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:6;-webkit-box-orient:vertical;position:relative;font-weight:400;font-size:16px;"], Global/* theme.blackText */.rS.blackText);
const AuthorSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__AuthorSection",
  componentId: "sc-98byxy-16"
})(["display:flex;align-items:center;gap:12px;margin-top:auto;"]);
const ProfileIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Testimonialsstyle__ProfileIcon",
  componentId: "sc-98byxy-17"
})(["width:56.8px;height:56.8px;object-fit:cover;"]);
const AuthorDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__AuthorDetails",
  componentId: "sc-98byxy-18"
})(["display:flex;flex-direction:column;gap:4px;"]);
const AuthorName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Testimonialsstyle__AuthorName",
  componentId: "sc-98byxy-19"
})(["font-size:16px;font-weight:600;color:#000;"]);
const DatePosted = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Testimonialsstyle__DatePosted",
  componentId: "sc-98byxy-20"
})(["font-size:12px;color:#666;"]);
const DotsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__DotsContainer",
  componentId: "sc-98byxy-21"
})(["display:flex;justify-content:center;gap:8px;margin-top:24px;"]);
const Dot = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Testimonialsstyle__Dot",
  componentId: "sc-98byxy-22"
})(["width:", ";height:8px;border-radius:4px;border:none;background-color:", ";cursor:pointer;transition:all 0.3s ease;padding:0;&:hover{background-color:", ";}"], props => props.active ? "24px" : "8px", props => props.active ? "#008CFF" : "#D0D0D0", props => props.active ? "#008CFF" : "#A0A0A0");
const TooltipWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__TooltipWrapper",
  componentId: "sc-98byxy-23"
})(["position:absolute;top:240px;right:20px;background:#2a5660;color:#fff;padding:12px 16px;border-radius:8px;font-size:13px;max-width:328px;box-shadow:0 4px 12px rgba(0,0,0,0.15);z-index:10;display:flex;align-items:center;gap:8px;&::before{content:\"\";position:absolute;top:-6px;right:150px;width:12px;height:12px;background:#2a5660;transform:rotate(45deg);}"]);
const CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Testimonialsstyle__CloseButton",
  componentId: "sc-98byxy-24"
})(["background:transparent;border:none;color:#fff;font-size:20px;cursor:pointer;padding:0;width:20px;height:20px;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-left:auto;&:hover{opacity:0.8;}"]);
const Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Testimonialsstyle__Separator",
  componentId: "sc-98byxy-25"
})(["height:1px;background:#d8d8d8;margin:16px 0;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TestimonialsSection/TestimonialsSection.tsx











const TestimonialsSection = ({
  data
}) => {
  const {
    0: currentIndex,
    1: setCurrentIndex
  } = (0,react.useState)(0);
  const {
    0: showTooltip,
    1: setShowTooltip
  } = (0,react.useState)(false); // const [value, setValue] = useState(false);

  const {
    0: hoveredCardIndex,
    1: setHoveredCardIndex
  } = (0,react.useState)(null);
  const contentRefs = (0,react.useRef)([]);
  const itemsPerView = 2;
  const maxIndex = Math.max(0, data.cards.length - Math.floor(itemsPerView));
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "testimonials_section_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: testimonialsSectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  }); // useEffect(() => {
  //   setTimeout(() => {
  //     setValue(true);
  //   }, 1000);
  // }, []);

  const handleNext = () => {
    setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
  };

  const handlePrev = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
  };

  const handleDotClick = index => {
    setCurrentIndex(index);
  };

  const isContentTruncated = element => {
    if (!element) return false;
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  };

  const renderStars = rating => {
    return Array.from({
      length: 5
    }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Star, {
      filled: index < rating,
      "data-test-id": `TestimonialsSection-renderStars-Star-${index}`,
      children: "\u2605"
    }, index));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialsSectionWrapper, {
    ref: testimonialsSectionRef,
    "data-test-id": "TestimonialsSection-TestimonialsSectionWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialsHeader, {
      "data-test-id": "TestimonialsSection-TestimonialsHeader",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TestimonialsSectionTitle, {
        "data-test-id": "TestimonialsSection-TestimonialsSectionTitle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.title,
          "data-test-id": "TestimonialsSection-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CarouselButton, {
        "data-test-id": "TestimonialsSection-CarouselButton",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ChevStateWrap, {
          left: true,
          onClick: handlePrev,
          disabled: currentIndex === 0,
          "data-test-id": "TestimonialsSection-ChevStateWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
            "data-test-id": "TestimonialsSection-BlueChev"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChevStateWrap, {
          onClick: handleNext,
          disabled: currentIndex >= maxIndex,
          "data-test-id": "TestimonialsSection-ChevStateWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
            "data-test-id": "TestimonialsSection-BlueChev"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWrapper, {
      "data-test-id": "TestimonialsSection-CarouselWrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselContent, {
        "data-test-id": "TestimonialsSection-CarouselContent",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardsContainer, {
          currentIndex: currentIndex,
          itemsPerView: itemsPerView,
          "data-test-id": "TestimonialsSection-CardsContainer",
          children: data.cards.map((card, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialCard, {
            onMouseEnter: () => {
              setHoveredCardIndex(index);

              if (isContentTruncated(contentRefs.current[index])) {
                setShowTooltip(true);
              }
            },
            onMouseLeave: () => {
              setHoveredCardIndex(null);
              setShowTooltip(false);
            },
            "data-test-id": `TestimonialsSection-TestimonialCard-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CardHeader, {
              "data-test-id": "TestimonialsSection-CardHeader",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: card.header.title,
                baseStyle: {
                  fontSize: "14px"
                },
                "data-test-id": "TestimonialsSection-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StarsContainer, {
                "data-test-id": "TestimonialsSection-StarsContainer",
                children: renderStars(card.header.ratings)
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {
              "data-test-id": "TestimonialsSection-Separator"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TestimonialContent, {
              ref: el => contentRefs.current[index] = el,
              "data-test-id": "TestimonialsSection-TestimonialContent",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: card.content.testimonial,
                "data-test-id": "TestimonialsSection-FormattedText"
              })
            }), showTooltip && hoveredCardIndex === index && /*#__PURE__*/(0,jsx_runtime.jsx)(TooltipWrapper, {
              "data-test-id": "TestimonialsSection-TooltipWrapper",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: card.content.testimonial,
                "data-test-id": "TestimonialsSection-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AuthorSection, {
              "data-test-id": "TestimonialsSection-AuthorSection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileIcon, {
                src: card.content.profileIcon,
                "data-test-id": "TestimonialsSection-ProfileIcon"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AuthorDetails, {
                "data-test-id": "TestimonialsSection-AuthorDetails",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AuthorName, {
                  "data-test-id": "TestimonialsSection-AuthorName",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: card.content.author,
                    "data-test-id": "TestimonialsSection-FormattedText"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DatePosted, {
                  "data-test-id": "TestimonialsSection-DatePosted",
                  children: (0,utils/* formatDate */.p6)((0,utils/* convertUnixToDate */.P9)(card.content.datePosted) || new Date(), src.DATE_FORMATS["DD-MMM-YYYY"]) || ""
                })]
              })]
            })]
          }, index))
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DotsContainer, {
      "data-test-id": "TestimonialsSection-DotsContainer",
      children: Array.from({
        length: maxIndex + 1
      }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Dot, {
        active: index === currentIndex,
        onClick: () => handleDotClick(index),
        "aria-label": `Go to slide ${index + 1}`,
        "data-test-id": `TestimonialsSection-Dot-${index}`
      }, index))
    })]
  });
};

/* harmony default export */ const TestimonialsSection_TestimonialsSection = (TestimonialsSection);

/***/ }),

/***/ 38985:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58524);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93139);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const AnchorTag = ({
  children,
  fontSize = "sm",
  fontWeight = "regular",
  color,
  handleClick,
  hrefProp,
  textAlign,
  margin,
  handleMouseEnter,
  handleMouseLeave,
  textTransform,
  anchorTitle,
  targetProp,
  download = false,
  disableState,
  width,
  lineHeight
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_0__/* .usePartnerContext */ .X)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .AnchorTagStyle */ .C2, {
    context: context ? context : undefined,
    textAlign: textAlign,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    onClick: handleClick,
    lineHeight: lineHeight,
    href: hrefProp,
    margin: margin,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    textTransform: textTransform,
    title: anchorTitle,
    target: targetProp,
    download: download,
    disableState: disableState,
    width: width,
    "data-test-id": "AnchorTag-AnchorTagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AnchorTag);

/***/ }),

/***/ 66630:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const H2Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__/* .usePartnerContext */ .X)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H2TagStyle */ .FI, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H2Tag-H2TagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (H2Tag);

/***/ }),

/***/ 64696:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const H3Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__/* .usePartnerContext */ .X)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H3TagStyle */ .KO, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H3Tag-H3TagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (H3Tag);

/***/ }),

/***/ 14485:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const H4Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__/* .usePartnerContext */ .X)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H4TagStyle */ .sz, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H4Tag-H4TagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (H4Tag);

/***/ }),

/***/ 9321:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const H5Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__/* .usePartnerContext */ .X)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H5TagStyle */ .Wl, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H5Tag-H5TagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (H5Tag);

/***/ }),

/***/ 79562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const H6Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__/* .usePartnerContext */ .X)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H6TagStyle */ .xT, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H6Tag-H6TagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (H6Tag);

/***/ }),

/***/ 75641:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const ParaTag = ({
  children,
  fontSize = "sm",
  fontWeight = "regular",
  color = "#000000",
  margin,
  textAlign,
  lineHeight,
  dangerousText,
  textTransform
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__/* .usePartnerContext */ .X)();
  return dangerousText ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .ParaTagStyle */ .OG, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle"
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .ParaTagStyle */ .OG, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ParaTag);

/***/ }),

/***/ 56893:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const SpanTag = ({
  fontSize = "sm",
  fontWeight = "regular",
  color = "black",
  margin,
  children,
  textTransform,
  dangerousText,
  style
}) => {
  if (dangerousText && typeof dangerousText !== "string") {
    dangerousText = String(dangerousText);
  }

  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_2__/* .usePartnerContext */ .X)();
  return dangerousText ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .SpanTagStyle */ .zs, {
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle"
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .SpanTagStyle */ .zs, {
    style: style,
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SpanTag);

/***/ }),

/***/ 93139:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": () => (/* binding */ AnchorTagStyle),
/* harmony export */   "FI": () => (/* binding */ H2TagStyle),
/* harmony export */   "KO": () => (/* binding */ H3TagStyle),
/* harmony export */   "OG": () => (/* binding */ ParaTagStyle),
/* harmony export */   "Wl": () => (/* binding */ H5TagStyle),
/* harmony export */   "sz": () => (/* binding */ H4TagStyle),
/* harmony export */   "xT": () => (/* binding */ H6TagStyle),
/* harmony export */   "zs": () => (/* binding */ SpanTagStyle)
/* harmony export */ });
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44928);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);




const renderFont = txtfontSize => {
  switch (txtfontSize) {
    case "xxs":
      return `
        font-size: 10px;
        line-height: 16px;
      `;

    case "xs":
      return `
        font-size: 12px;
        line-height: 16px;
      `;

    case "sm":
      return `
        font-size: 0.875rem;
        line-height: 20px;
      `;

    case "md":
      return `
        font-size: 1em;
        line-height: 22px;
      `;

    case "large":
      return `
        font-size: 18px;
        line-height: 24px;
      `;

    case "xlarge":
      return `
        font-size: 1.375rem;
        line-height: 26px;
      `;

    /* istanbul ignore next */

    case "xxlarge":
      return `
        font-size: 1.5em;
        line-height: 32px;
      `;

    /* istanbul ignore next */

    case "xxxlarge":
      return `
        font-size: 1.75em;
        line-height: 32px;
      `;

    /* istanbul ignore next */

    default:
      return `
        font-size: 0.875em;
        line-height: 20px;
      `;
  }
};

const renderFontWeight = (txtfontWeight, context) => {
  switch (txtfontWeight) {
    case "regular":
      return `
          font-weight: 400;
        `;

    case "bold":
      return `
          ${context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "font-weight: 700" : "font-weight: 500"};
      `;

    case "black":
      return `
           ${context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "font-weight: 900" : "font-weight: 700"};
        `;

    default:
      return `
      font-weight: 400;
    `;
  }
};

const H2TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "sc-1ci0hiy-0"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "36px" : "32px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "44px" : "37px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H3TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "sc-1ci0hiy-1"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";text-align:var(--textAlign,left);font-variant-numeric:lining-nums proportional-nums;"], p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "32px" : "24px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "38px" : "28px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H4TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "sc-1ci0hiy-2"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "24px" : "22px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "28px" : "26px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H5TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "sc-1ci0hiy-3"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "22px" : "18px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "26px" : "21px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H6TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "sc-1ci0hiy-4"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "18px" : "16px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "21px" : "18px", p => p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const ParaTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "sc-1ci0hiy-5"
})(["", " ", " margin:", ";text-align:", ";color:", ";line-height:", ";text-transform:", ";& > .boldText{font-weight:700;}word-break:break-word;"], p => p.txtfontSize ? `
    ${renderFont(p.txtfontSize)}
  ` : ``, p => p.txtfontWeight && `
    ${renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined)}
  `, p => p.margin && p.margin, p => p.textAlign && p.textAlign, p => p.txtcolor && p.txtcolor, p => p.lineHeight && p.lineHeight, p => p.textTransform && p.textTransform);
const SpanTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "sc-1ci0hiy-6"
})(["", " ", " display:inline-block;color:", ";margin:", ";text-transform:", ";word-break:break-word;"], p => p.txtfontSize ? `${renderFont(p.txtfontSize)}` : `inherit`, p => p.txtfontWeight && `
    ${renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined)}
  `, p => p.txtcolor && p.txtcolor, p => p.margin && p.margin, p => p.textTransform && p.textTransform);
const AnchorTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "sc-1ci0hiy-7"
})(["", " ", " margin:", ";display:inline-block;color:", ";text-align:", ";text-transform:", ";width:", ";line-height:", ";", ""], p => p.txtfontSize ? `${renderFont(p.txtfontSize)}` : ``, p => p.txtfontWeight && `
    ${renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined)}
  `, p => p.margin && p.margin, p => p.txtcolor ? p.txtcolor : _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, p => p.textAlign && p.textAlign, p => p.textTransform && p.textTransform, p => p.width ?? "auto", p => p.lineHeight && p.lineHeight, p => p.disableState && `
    opacity:0.5;
    pointer-events:none;
    `);

/***/ }),

/***/ 32888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TickRadioComp_TickRadioComp)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TickRadioComp/TickRadioComp.style.ts

const TickRadioWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TickRadioCompstyle__TickRadioWrapper",
  componentId: "fhl4i5-0"
})(["cursor:pointer;user-select:none;width:100%;"]);
const HiddenRadioInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "TickRadioCompstyle__HiddenRadioInput",
  componentId: "fhl4i5-1"
})(["display:none;"]);
const RadioLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "TickRadioCompstyle__RadioLabel",
  componentId: "fhl4i5-2"
})(["display:flex;align-items:center;gap:8px;cursor:pointer;width:100%;"]);
const RadioCircle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TickRadioCompstyle__RadioCircle",
  componentId: "fhl4i5-3"
})(["width:18px;height:18px;border-radius:50%;border:1.5px solid ", ";background:", ";display:flex;align-items:center;justify-content:center;flex-shrink:0;position:relative;transition:all 0.2s ease;", ""], props => props.isSelected ? "var(--tm-accent-color)" : "#999", props => props.isSelected ? "var(--tm-accent-color)" : "#fff", props => props.isSelected && `
    &::after {
      content: "";
      display: block;
      width: 4px;
      height: 8px;
      border: solid #fff;
      border-width: 0 1.5px 1.5px 0;
      transform: rotate(45deg);
      margin-top: -2px;
    }
  `);
const RadioLabelContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TickRadioCompstyle__RadioLabelContent",
  componentId: "fhl4i5-4"
})(["display:flex;align-items:center;gap:8px;flex:1;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TickRadioComp/TickRadioComp.tsx





const TickRadioComp = ({
  children,
  isSelected,
  onClick,
  inputId
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TickRadioWrapper, {
    onClick: onClick,
    isSelected: isSelected,
    "data-test-id": "TickRadioComp-TickRadioWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiddenRadioInput, {
      type: "radio",
      id: inputId,
      checked: isSelected,
      onChange: onClick,
      "data-test-id": "TickRadioComp-HiddenRadioInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RadioLabel, {
      htmlFor: inputId,
      "data-test-id": "TickRadioComp-RadioLabel",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RadioCircle, {
        isSelected: isSelected,
        "data-test-id": "TickRadioComp-RadioCircle"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RadioLabelContent, {
        "data-test-id": "TickRadioComp-RadioLabelContent",
        children: children
      })]
    })]
  });
};

/* harmony default export */ const TickRadioComp_TickRadioComp = (TickRadioComp);

/***/ }),

/***/ 26217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TncComp_TncComp)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.tsx
var CheckButton = __webpack_require__(97004);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/ParaTag.tsx
var ParaTag = __webpack_require__(75641);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TncComp/TncComp.styles.ts

const ConfirmTnc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TncCompstyles__ConfirmTnc",
  componentId: "sc-1rz695v-0"
})(["background:#ffffff;border-radius:16px;padding:12px 24px;font-size:14px;line-height:20px;color:#4a4a4a;font-weight:400;gap:8px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TncComp/TncComp.tsx









const TncComp = /*#__PURE__*/(0,react.forwardRef)((data, ref) => {
  const {
    tnc,
    link,
    error,
    handleTncCheckbox,
    isLoading
  } = data;
  const {
    control,
    formState: {
      errors
    }
  } = (0,index_esm/* useFormContext */.Gc)();
  const internalRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, () => internalRef.current);
  const tncError = errors.tncs?.find?.(item => item?.message);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConfirmTnc, {
    ref: internalRef,
    "data-test-id": "TncComp-ConfirmTnc",
    children: [tnc?.map((tncElement, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
      control: control,
      name: `tncs.${index}`,
      rules: {
        required: {
          value: true,
          message: "Please confirm"
        }
      },
      render: ({
        field: {
          value
        }
      }) => /*#__PURE__*/(0,jsx_runtime.jsx)(CheckButton/* default */.Z, {
        inputId: "confirmTnC",
        handleChange: () => {
          handleTncCheckbox?.(index);
        },
        isChecked: value,
        "data-test-id": "TncComp-CheckButton",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: tncElement,
            "data-test-id": "TncComp-FormattedText"
          })
        })
      }),
      "data-test-id": `TncComp-Controller-${index}`
    }, index)), tncError && /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
      margin: "0px 0 0 4px",
      color: Global/* theme.redText2 */.rS.redText2,
      fontSize: "xs",
      "data-test-id": "TncComp-ParaTag",
      children: error?.message
    })]
  });
});
TncComp.displayName = "TncComp";
/* harmony default export */ const TncComp_TncComp = (TncComp);

/***/ }),

/***/ 67929:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ih": () => (/* binding */ ToastIcon),
/* harmony export */   "iA": () => (/* binding */ CloseIconWrap),
/* harmony export */   "jf": () => (/* binding */ ToastStyle)
/* harmony export */ });
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93139);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45590);




const ToastStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Toaststyle__ToastStyle",
  componentId: "mow44r-0"
})(["display:flex;align-items:center;justify-content:space-between;padding:12px 18px;background:#4a4a4a;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:12px;width:436px;position:fixed;bottom:30px;right:30px;gap:8px;", "{flex-shrink:0;}", "{width:127px;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_0__/* .SpanTagStyle */ .zs, _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_3__/* .LandingButtonTertiaryStyle */ .mS, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const CloseIconWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Toaststyle__CloseIconWrap",
  componentId: "mow44r-1"
})(["width:28px;height:28px;cursor:pointer;"]);
const ToastIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Toaststyle__ToastIcon",
  componentId: "mow44r-2"
})(["display:flex;flex-shrink:0;"]);

/***/ }),

/***/ 2660:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Toast_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67929);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const Toast = ({
  toastCtaTxt,
  planSelectedTxt,
  handleClickCta,
  handleClose,
  autoCloseDuration = 3000,
  toastCloseIcon,
  toastIcon,
  isDisable,
  showToast,
  width,
  height
}) => {
  const {
    0: visible,
    1: setVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    let timer;

    if (autoCloseDuration) {
      timer = setTimeout(() => {
        if (visible) {
          setVisible(false);
        }
      }, autoCloseDuration);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [autoCloseDuration, visible]);
  return visible ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_Toast_style__WEBPACK_IMPORTED_MODULE_1__/* .ToastStyle */ .jf, {
    "data-test-id": "Toast-ToastStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FlexComp, {
      gap: "16px",
      alignItems: "center",
      "data-test-id": "Toast-FlexComp",
      children: [toastIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Toast_style__WEBPACK_IMPORTED_MODULE_1__/* .ToastIcon */ .Ih, {
        "data-test-id": "Toast-ToastIcon",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
          width: width ? width : "50px",
          height: height ? height : "50px",
          src: toastIcon,
          "data-test-id": "Toast-ImageComponent"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.SpanTag, {
        fontSize: "md",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.whiteText */ .rS.whiteText,
        "data-test-id": "Toast-SpanTag",
        children: planSelectedTxt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FormattedText, {
          value: planSelectedTxt,
          "data-test-id": "Toast-FormattedText"
        })
      })]
    }), toastCtaTxt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.LandingButtonWhite, {
      customTitle: toastCtaTxt,
      onClick: handleClickCta,
      disableState: isDisable,
      "data-test-id": "Toast-LandingButtonWhite"
    }), toastCloseIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Toast_style__WEBPACK_IMPORTED_MODULE_1__/* .CloseIconWrap */ .iA, {
      onClick: handleClose,
      "data-test-id": "Toast-CloseIconWrap",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon,
        "data-test-id": "Toast-ImageComponent"
      })
    })]
  }) : null;
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Toast);

/***/ }),

/***/ 91703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Toast_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67929);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87109);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const ToastCompare = ({
  toastCtaTxt,
  planSelectedTxt,
  handleClickCta,
  handleClose,
  toastCloseIcon,
  toastIcon,
  isDisable,
  width,
  height
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_Toast_style__WEBPACK_IMPORTED_MODULE_1__/* .ToastStyle */ .jf, {
    "data-test-id": "ToastCompare-ToastStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FlexComp, {
      gap: "4px",
      alignItems: "center",
      "data-test-id": "ToastCompare-FlexComp",
      children: [toastIcon && device == "lg" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Toast_style__WEBPACK_IMPORTED_MODULE_1__/* .ToastIcon */ .Ih, {
        "data-test-id": "ToastCompare-ToastIcon",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
          width: width ? width : "50px",
          height: height ? height : "50px",
          src: toastIcon,
          "data-test-id": "ToastCompare-ImageComponent"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.SpanTag, {
        fontSize: device == "lg" ? "md" : "xs",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.whiteText */ .rS.whiteText,
        "data-test-id": "ToastCompare-SpanTag",
        children: planSelectedTxt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FormattedText, {
          value: planSelectedTxt,
          "data-test-id": "ToastCompare-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.LandingButtonTertiary, {
      title: toastCtaTxt,
      onClick: handleClickCta,
      disableState: isDisable,
      "data-test-id": "ToastCompare-LandingButtonTertiary"
    }), toastCloseIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Toast_style__WEBPACK_IMPORTED_MODULE_1__/* .CloseIconWrap */ .iA, {
      onClick: handleClose,
      "data-test-id": "ToastCompare-CloseIconWrap",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon,
        "data-test-id": "ToastCompare-ImageComponent"
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ToastCompare);

/***/ }),

/***/ 78891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Toast_WebToast)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.style.tsx



const WebToastStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WebToaststyle__WebToastStyle",
  componentId: "sc-937kgh-0"
})(["position:", ";top:", ";left:", ";width:", ";height:", ";background:", ";display:flex;align-items:", ";z-index:200;justify-content:", ";box-shadow:0px 3px 30px rgba(0,0,0,0.16);", " padding:12px 16px 12px 16px;border-radius:6px;bottom:", ";right:", ";picture{height:19px;width:19px;padding:2px;}", "{flex-shrink:0;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], p => p.position ? `${p.position}` : `absolute`, p => `${p.top}`, p => `${p.left}`, p => `${p.width}`, p => `${p.height}`, p => p.background ? `${p.background}` : `#4a4a4a`, p => p.alignItems ? `${p.alignItems}` : `center`, p => p.justifyContent ? `${p.justifyContent}` : `space-between`, p => p.margin && `margin: ${p.margin};`, p => `${p.bottom}`, p => `${p.right}`, TextStyles_style/* SpanTagStyle */.zs, src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx






const TOAST_BG_COLOR = {
  error: "#FCDADB",
  success: "#B8F5E0",
  default: "#4A4A4A",
  warning: "#FFEDD1"
};

const WebToast = ({
  iconUrl,
  position,
  toastTxt,
  fontSize,
  fontWeight,
  toastTxtMargin,
  top,
  left,
  margin,
  width,
  bottom,
  right,
  height,
  type = "default",
  color
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WebToastStyle, {
    top: top,
    bottom: bottom,
    right: right,
    left: left,
    width: width,
    height: height,
    margin: margin,
    position: position,
    justifyContent: type === "success" || type === "warning" ? "center" : "space-between",
    background: TOAST_BG_COLOR[type],
    "data-test-id": "WebToast-WebToastStyle",
    children: [iconUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
      height: "15px",
      width: "15px",
      src: iconUrl,
      "data-test-id": "WebToast-ImageComponent"
    }), toastTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(FlexComp/* default */.Z, {
      gap: "10px",
      alignItems: "center",
      "data-test-id": "WebToast-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: toastTxt,
        baseStyle: {
          fontSize: fontSize ? fontSize : "12px",
          fontWeight: fontWeight ? fontWeight : "normal",
          color: color ? color : "#FFFFFF",
          margin: toastTxtMargin ? toastTxtMargin : "10px"
        },
        "data-test-id": "WebToast-FormattedText"
      })
    })]
  });
};

/* harmony default export */ const Toast_WebToast = (WebToast);

/***/ }),

/***/ 45874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ ToolTipCompWrapper)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const ToolTipCompWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ToolTipCompstyle__ToolTipCompWrapper",
  componentId: "sc-7xkig7-0"
})(["position:absolute;background:", ";border:4px solid ", ";left:", ";right:", ";top:", ";bottom:", ";width:", ";font-size:14px;line-height:20px;padding:8px;border-radius:4px;gap:20px;z-index:", ";color:#ffffff;&:after,&:before{border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(0,0,0,0);border-width:13px;}&:before{border-color:rgba(0,0,0,0);border-width:13px;}", " ", " ", " ", ""], props => props.backgroundColor, props => props.backgroundColor, props => props.left, props => props.right, props => props.top, props => props.bottom, props => props.width, props => props.zIndex, props => props.toolTipArrow == "top" && `
&:after, &:before {
	bottom: 100%;
	left: 50%;
}

&:after {
  border-bottom-color: ${props.backgroundColor};
	margin-top: -30px;
}
&:before {
	border-bottom-color: ${props.backgroundColor};
	margin-top: -36px;
}

`, props => props.toolTipArrow == "bottom" && `
&:after, &:before {
	top: 100%;
	left: 50%;
}

&:after {
	border-top-color: ${props.backgroundColor};
	margin-left: -34px;
}
&:before {
	border-top-color: ${props.backgroundColor};
	margin-left: -36px;
}

`, props => props.toolTipArrow == "right" && `
&:after, &:before {
	left: 100%;
	top: 50%;
}

&:after {
	border-left-color: ${props.backgroundColor};
	margin-top: -30px;
}
&:before {
	border-left-color: ${props.backgroundColor};
	margin-top: -36px;
}

`, props => props.toolTipArrow == "left" && `
&:after, &:before {
	right: 100%;
	top: 50%;
}

&:after {
	border-right-color: ${props.backgroundColor};
	margin-top: -17px;
}
&:before {
	border-right-color: ${props.backgroundColor};
	margin-top: -19px;
}

`);

/***/ }),

/***/ 94510:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _ToolTipComp_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);




const ToolTipComp = ({
  message,
  top,
  left,
  right,
  bottom,
  width,
  backgroundColor = "#1a7971",
  toolTipArrow,
  children,
  handleMouseEnter,
  handleMouseLeave,
  zIndex
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_ToolTipComp_style__WEBPACK_IMPORTED_MODULE_1__/* .ToolTipCompWrapper */ .V, {
    width: width,
    top: top,
    left: left,
    right: right,
    bottom: bottom,
    backgroundColor: backgroundColor,
    toolTipArrow: toolTipArrow,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    zIndex: zIndex,
    "data-test-id": "ToolTipComp-ToolTipCompWrapper",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ToolTipComp);

/***/ }),

/***/ 54664:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TravAssistant_TravAssistant)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravAssistant/TravAssistant.style.ts


const TravAssistantStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravAssistantstyle__TravAssistantStyle",
  componentId: "iorioc-0"
})(["border-radius:16px;border:1px solid #e2e2e2;background:#fff;padding:16px;@media ", "{border-radius:0;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravAssistant/TravAssistant.tsx








const TravAssistant = ({
  cardTitle,
  cardInfo,
  helpLineNo,
  cardIcon
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravAssistantStyle, {
    "data-test-id": "TravAssistant-TravAssistantStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      gap: "8px",
      borderBottom: "1px solid #e2e2e2",
      padding: "0 0 8px",
      margin: "0 0 10px",
      "data-test-id": "TravAssistant-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "24px",
        height: "24px",
        src: cardIcon,
        "data-test-id": "TravAssistant-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [cardTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontSize: "md",
          fontWeight: "bold",
          color: Global/* theme.greenText */.rS.greenText,
          "data-test-id": "TravAssistant-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: cardTitle,
            "data-test-id": "TravAssistant-FormattedText"
          })
        }), cardInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          "data-test-id": "TravAssistant-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: cardInfo,
            "data-test-id": "TravAssistant-FormattedText"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      alignItems: "center",
      gap: "8px",
      "data-test-id": "TravAssistant-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Phone_8b0592cec7.svg",
        "data-test-id": "TravAssistant-ImageComponent"
      }), helpLineNo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        fontWeight: "bold",
        "data-test-id": "TravAssistant-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: helpLineNo,
          "data-test-id": "TravAssistant-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const TravAssistant_TravAssistant = (TravAssistant);

/***/ }),

/***/ 25941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C0": () => (/* binding */ ViewOrder),
/* harmony export */   "Fk": () => (/* binding */ TravellingToCardStyle),
/* harmony export */   "Me": () => (/* binding */ TravelNote),
/* harmony export */   "Nj": () => (/* binding */ PopularCountry),
/* harmony export */   "P5": () => (/* binding */ BgText),
/* harmony export */   "QQ": () => (/* binding */ PopularCountryItem),
/* harmony export */   "Q_": () => (/* binding */ CountryImg),
/* harmony export */   "S_": () => (/* binding */ DiscountingNote),
/* harmony export */   "TR": () => (/* binding */ TripUpcoming),
/* harmony export */   "Vr": () => (/* binding */ UpcomingTripStyle),
/* harmony export */   "cM": () => (/* binding */ UpcomingTripTag),
/* harmony export */   "fK": () => (/* binding */ TravellingToStyleWrap),
/* harmony export */   "in": () => (/* binding */ OtherCountyBtn),
/* harmony export */   "s0": () => (/* binding */ TravellingToStyle),
/* harmony export */   "xZ": () => (/* binding */ CountryNameTxt)
/* harmony export */ });
/* unused harmony exports TravelDetailsStyle, ButtonWrapper */
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44928);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84576);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82740);
/* harmony import */ var _Tags_Tags_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67483);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93139);






const TravelDetailsStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelDetailsStyle",
  componentId: "sc-4x930j-0"
})(["background:#ffffff;padding:30px;"]);
const TravellingToCardStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToCardStyle",
  componentId: "sc-4x930j-1"
})(["padding:30px;@media ", "{padding:16px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const TravellingToStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyle",
  componentId: "sc-4x930j-2"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;position:relative;display:flex;flex-direction:column;justify-content:space-between;min-height:100%;", "{padding:5px;margin:-5px;}@media ", "{margin-bottom:36px;}"], _Tags_Tags_style__WEBPACK_IMPORTED_MODULE_4__/* .TagsStyle */ .E, _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const PopularCountry = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountry",
  componentId: "sc-4x930j-3"
})(["display:flex;flex-wrap:wrap;gap:8px;label{left:0 !important;position:absolute;bottom:8px;z-index:1;}@media ", "{margin-bottom:16px;display:grid;grid-template-columns:repeat(3,1fr);grid-gap:14px;width:calc(100vw - 64px);min-height:178px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const PopularCountryItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountryItem",
  componentId: "sc-4x930j-4"
})(["background:linear-gradient(228.82deg,#43c6ac 2.05%,#191654 93.35%);border:1px solid #fff;border-radius:6px;z-index:1;padding:8px;overflow:hidden;width:80px;height:82px;position:relative;flex-shrink:0;cursor:pointer;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);", " > div{cursor:pointer;}picture{height:82px;}@media ", "{width:unset;height:82px;picture{height:82px;}}"], p => p.listSelected && `
        border: 1px solid #008cff;
        `, _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const OtherCountyBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__OtherCountyBtn",
  componentId: "sc-4x930j-5"
})(["display:flex;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);flex-direction:column;gap:8px;width:80px;height:82px;background:#fff;border-radius:6px;padding:", ";cursor:pointer;@media ", "{width:unset;height:82px;gap:6px;}"], p => p.theme.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MYBIZ ? "8px 3px" : "8px", _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const CountryImg = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__CountryImg",
  componentId: "sc-4x930j-6"
})(["position:absolute;top:0px;left:0px;bottom:0;z-index:-1;max-width:100%;max-height:100%;width:100%;picture{width:100%;}picture img{width:80px;height:80px;}:after{content:\"\";position:absolute;border-radius:0px 0px 6px 6px;background:linear-gradient( 180deg,rgba(106,106,106,0) 0%,rgba(0,0,0,0.7) 100% );width:100%;height:32px;bottom:1px;left:0;}@media ", "{picture img{width:100%;height:82px;}}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const TravelNote = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelNote",
  componentId: "sc-4x930j-7"
})(["background:linear-gradient( 85.23deg,rgba(67,225,168,0.5) 0%,rgba(33,147,147,0.5) 100% );border-radius:8px 8px 0px 0px;padding:8px 78px;margin:0 auto;color:#fff;font-size:16px;width:550px;text-align:center;em{font-weight:600;color:#8beecd;font-style:normal;}@media ", "{width:92%;padding:12px;font-size:12px;text-align:center;padding-bottom:24px;margin-bottom:-12px;}@media ", "{", "}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile, _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.desktop */ .vO.desktop, p => p.theme.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? `
        background: linear-gradient(45deg, #43E1A8 0%, #219393 100%);
    ` : p.theme.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.GI ? `background: #18A160;` : ``);
const ViewOrder = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__ViewOrder",
  componentId: "sc-4x930j-8"
})(["font-size:12px;font-weight:900;"]);
const DiscountingNote = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__DiscountingNote",
  componentId: "sc-4x930j-9"
})(["border-radius:8px 8px 0px 0px;padding:8px 0px 8px 16px;margin:0 auto;color:", ";width:550px;display:flex;align-items:center;@media ", "{width:92%;padding:12px;padding-bottom:24px;margin-bottom:-12px;background:", ";}@media ", "{background:", ";}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText5 */ .rS.greyText5, _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile, p => p.theme.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MYBIZ ? "none" : "#e4fbf4", _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.desktop */ .vO.desktop, p => p.theme.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MYBIZ ? "none" : "#e4fbf4");
const TravellingToStyleWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyleWrap",
  componentId: "sc-4x930j-10"
})([""]);
const UpcomingTripStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripStyle",
  componentId: "sc-4x930j-11"
})(["display:flex;align-items:center;justify-content:space-between;background:#ffffff;border-radius:6px;padding:24px 12px 12px;margin-bottom:16px;position:relative;cursor:pointer;", " ", "{width:24px;height:24px;}&::before{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border:1px solid transparent;background:", ";-webkit-mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;border-radius:6px;}"], p => p.selected && `
    background: #EAF5FF;
    border: 1px solid #008CFF;
  `, _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_5__/* .AnchorTagStyle */ .C2, _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.purpleGradient */ .rS.purpleGradient);
const UpcomingTripTag = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripTag",
  componentId: "sc-4x930j-12"
})(["background:", ";padding:2px 6px;border-radius:6px 0px 6px 0px;width:fit-content;position:absolute;top:0;left:0;display:flex;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.purpleGradient */ .rS.purpleGradient);
const BgText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__BgText",
  componentId: "sc-4x930j-13"
})(["background:radial-gradient( 59.37% 231.91% at 3.11% 23.44%,rgba(255,255,255,0.24) 0%,rgba(255,255,255,0.144) 100% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-style:normal;font-weight:700;font-size:56px;line-height:64px;position:absolute;top:-59px;right:6px;"]);
const TripUpcoming = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TripUpcoming",
  componentId: "sc-4x930j-14"
})(["background:linear-gradient( 91.22deg,#9c005e 1.88%,rgba(22,20,60,0.2) 100% );padding:2px 8px;color:#fff;position:absolute;bottom:24px;left:-10px;white-space:nowrap;width:100%;font-weight:400;font-size:9px;line-height:11px;text-transform:uppercase;text-wrap:wrap;"]);
const CountryNameTxt = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__CountryNameTxt",
  componentId: "sc-4x930j-15"
})(["display:-webkit-box;color:#ffffff;font-size:12px;-webkit-line-clamp:2;font-weight:700;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;white-space:normal;width:75%;text-shadow:0px 0px 8px rgba(0,0,0,0.8);"]);
const ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__ButtonWrapper",
  componentId: "sc-4x930j-16"
})(["position:fixed;bottom:0;background:#fff;padding:16px;left:0;right:0;width:100%;z-index:1;"]);

/***/ }),

/***/ 16829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TravelDetails_TravellingTo)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 1 modules
var utility_src = __webpack_require__(97427);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DescriptionModal/DescriptionModal.tsx + 1 modules
var DescriptionModal = __webpack_require__(57989);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx + 1 modules
var WebToast = __webpack_require__(78891);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravelDetails.style.ts
var TravelDetails_style = __webpack_require__(25941);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/PopularCountryCompV2.tsx










const PopularCountryComp = ({
  popCountry,
  handleShowOtherCountry,
  otherCountryTxt,
  handlePopularCountrySelect,
  setIsSelectedError,
  setCountrySelectToastMsg
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const isCheckedHandler = (0,react.useCallback)(data => {
    return data?.isSelected;
  }, [popCountry]);
  const handleErrorToast = (0,utils/* debounce */.Ds)(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelect = item => {
    if (item.isDisabled) {
      const isExclusiveCountrySelected = popCountry?.find(item => item.isExclusiveSelection && item.isSelected);

      if (isExclusiveCountrySelected && !item?.isExclusiveSelection && item.isDisabled) {
        setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
        handleErrorToast();
      } else if (item?.isExclusiveSelection && !isExclusiveCountrySelected && item.isDisabled) {
        setCountrySelectToastMsg("India cannot be chosen for International Travel");
        handleErrorToast();
      } else if (item.isDisabled) {
        setIsSelectedError(true);
        handleErrorToast();
      }
    } else {
      handlePopularCountrySelect(item.code);
    }
  };

  const getGrey = item => {
    const isExclusiveCountrySelected = popCountry?.find(country => country.isExclusiveSelection && country.isSelected);

    if (isExclusiveCountrySelected && !item.isExclusiveSelection && item.isDisabled) {
      return true;
    }

    if (item.isExclusiveSelection && item.isDisabled) {
      return true;
    }

    return false;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountry */.Nj, {
    "data-test-id": "PopularCountryComp-PopularCountry",
    children: [popCountry && popCountry.slice(0, 5).map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountryItem */.QQ, {
        listSelected: isCheckedHandler(item),
        onClick: () => handleCountrySelect(item),
        "data-test-id": `PopularCountryComp-PopularCountryItem-${index}`,
        children: [index !== popCountry.length && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.CheckButton, {
          isDisabled: item.isDisabled,
          greyOut: getGrey(item),
          isChecked: item.isDisabled ? true : isCheckedHandler(item),
          "data-test-id": "PopularCountryComp-CheckButton",
          children: [!item.img && item.name && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* BgText */.P5, {
            "data-test-id": "PopularCountryComp-BgText",
            children: item?.code
          }), item.upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TripUpcoming */.TR, {
            "data-test-id": "PopularCountryComp-TripUpcoming",
            children: "TRIP UPCOMING"
          }), item?.name && !item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item?.name
          }), item?.name && item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name + item.subtitle,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item?.name + " " + item.subtitle
          })]
        }), item?.img && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryImg */.Q_, {
          "data-test-id": "PopularCountryComp-CountryImg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: device == "sm" ? "100%" : "80px",
            height: device == "lg" ? "80px" : "82px",
            src: item.img,
            loading: "eager",
            "data-test-id": "PopularCountryComp-ImageComponent"
          })
        })]
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* OtherCountyBtn */["in"], {
      onClick: handleShowOtherCountry,
      "data-test-id": "PopularCountryComp-OtherCountyBtn",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "24px",
        height: "24px",
        src: context === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_27565_cc0104059a.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
        loading: "eager",
        "data-test-id": "PopularCountryComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: `var(--tm-accent-color)`,
        "data-test-id": "PopularCountryComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: otherCountryTxt,
          "data-test-id": "PopularCountryComp-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const PopularCountryCompV2 = (PopularCountryComp);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var static_utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var ui_src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/UpcomingTrips.tsx











const analytics = (0,insurance/* getAnalytics */.I)();

const UpcomingTrips = ({
  country,
  travelDuration,
  travellerNum,
  travellerTitle,
  handleUpcomingTripClick
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const {
    0: isUpcomingTripSelected,
    1: setIsUpcomingTripSelected
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const isUpcomingTrip = queryParams.get("isUpcomingTrip");

    if (isUpcomingTrip) {
      setIsUpcomingTripSelected(true);
    }

    analytics?.trackLandingEvents({
      actionType: "upcoming_trips_shown"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_trips_shown"
      }
    });
  }, []);

  const showFormattedDate = date => {
    if (date) {
      const dateValue = (0,static_utils/* convertUnixToDate */.P9)(date);
      return (0,static_utils/* formatDate */.p6)(dateValue, static_utils/* DATE_FORMATS.DD MMM YY */.lv["DD MMM YY"]);
    }

    return "";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* UpcomingTripStyle */.Vr, {
    selected: isUpcomingTripSelected,
    onClick: handleUpcomingTripClick,
    "data-test-id": "UpcomingTrips-UpcomingTripStyle",
    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* UpcomingTripTag */.cM, {
      "data-test-id": "UpcomingTrips-UpcomingTripTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xxs",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: "UPCOMING TRIP"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      flexDirection: "column",
      "data-test-id": "UpcomingTrips-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
        fontWeight: "bold",
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: country,
          "data-test-id": "UpcomingTrips-FormattedText"
        }), "\xA0"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
        fontSize: "xs",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [` ${showFormattedDate(travelDuration?.startDate)} - ${showFormattedDate(travelDuration?.endDate)}`, " ", "| ", travellerNum, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: travellerTitle,
          "data-test-id": "UpcomingTrips-FormattedText"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
      "data-test-id": "UpcomingTrips-AnchorTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageTag, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
        width: "16px",
        height: "16px",
        "data-test-id": "UpcomingTrips-ImageTag"
      })
    })]
  });
};

/* harmony default export */ const TravelDetails_UpcomingTrips = (UpcomingTrips);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var lib_analytics = __webpack_require__(11508);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents.ts + 1 modules
var xdmEvents = __webpack_require__(46535);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonLandingDT/SegmentModal.tsx
var SegmentModal = __webpack_require__(21348);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravellingTo.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

























const TravellingTo_analytics = (0,insurance/* getAnalytics */.I)();

const TravellingTo = ({
  travellingToSection,
  upcomingTrip,
  calendarDatesLimit,
  travelSearchBanner,
  btnDisabledState = true,
  nextPageRoute,
  query,
  segmentId,
  countryCode,
  seoPageType
}) => {
  const buttonRef = (0,react.useRef)(null);
  const travellingToRef = (0,react.useRef)(null);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const {
    otherCountryTxt,
    travelNote,
    travDateTitle,
    travCountTitle,
    travCountSubtitle,
    travPurpTitle,
    travelPurposeTxt,
    popularCountryTxt,
    travelBtnTxt,
    travelSearchForm,
    travellerInfoSection,
    viewOrders,
    footerSection,
    agentAgreementSection,
    travellerBookingFor,
    travCounterTitle,
    travCountLimit
  } = travellingToSection || {};
  const {
    domesticProductOfferBanner,
    internationalProductOfferBanner,
    productOfferBanner
  } = travelSearchForm || {};
  const {
    label,
    error_message,
    countrySelectErrMsg,
    placeHolder,
    value
  } = travelSearchForm.regionCountryList;
  const {
    countryData: totalCountryData,
    popularCountryData
  } = (0,static_utils/* processCountryDataFromQuery */.GZ)(value || [], query, upcomingTrip, countryCode);
  const {
    0: popularCountries,
    1: setPopularCountries
  } = (0,react.useState)(popularCountryData || []);
  const {
    0: countryData,
    1: setCountryData
  } = (0,react.useState)(totalCountryData || []);
  const {
    0: showOtherCountry,
    1: setOtherCountry
  } = (0,react.useState)(false);
  const {
    0: countValue,
    1: setCountValue
  } = (0,react.useState)(0);
  const {
    0: calenderValue,
    1: setCalenderValue
  } = (0,react.useState)();
  const {
    0: showCountry,
    1: setShowCountry
  } = (0,react.useState)(popularCountryData || []);
  const {
    0: isCountryError,
    1: setIsCountryError
  } = (0,react.useState)(false);
  const {
    0: descriptionTxt,
    1: setDescriptionTxt
  } = (0,react.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: descTitle,
    1: setDescTitle
  } = (0,react.useState)("");
  const {
    0: segments,
    1: setSegments
  } = (0,react.useState)([]);
  const {
    0: segmentSelected,
    1: setSegmentSelected
  } = (0,react.useState)({});
  const {
    0: travAgeRange,
    1: setTravAgeRange
  } = (0,react.useState)([]);
  const {
    0: isSegmentModalShown,
    1: setIsSegmentModalShown
  } = (0,react.useState)(false);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react.useState)("");
  const {
    0: isAgeRangeSelectedError,
    1: setIsAgeRangeSelectedError
  } = (0,react.useState)(false);
  const {
    0: showAgreementModal,
    1: setShowAgreementModal
  } = (0,react.useState)(false);
  const {
    0: agreementSource,
    1: setAgreementSource
  } = (0,react.useState)("");
  const {
    0: lastCalendarTypeSingle,
    1: setLastCalendarTypeSingle
  } = (0,react.useState)(false);
  const {
    0: isConsented,
    1: setIsConsented
  } = (0,react.useState)(false);
  const {
    0: nextPageError,
    1: setNextPageError
  } = (0,react.useState)();
  const preSelectedSegment = travelSearchForm?.segments?.value?.find(item => item.id === query?.segment || seoPageType === "SEGMENT" && segmentId && item.id === segmentId || !query?.segment && !segmentId && item.isSelected); //set the default selected segement

  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment") || seoPageType === "SEGMENT" && segmentId;
    const segments = travelSearchForm?.segments?.value;

    if (segments) {
      const segment = segments.find(item => item.id === segParam || !segParam && item.isSelected);

      if (segment) {
        setSegmentSelected(segment);
        (0,utils/* replaceHistory */.df)("segment", segment.id);
      }
    }
  }, []); //set the travelSerachForm.segments to segments

  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment") || seoPageType === "SEGMENT" && segmentId;

    if (travelSearchForm?.segments?.value) {
      if (segParam) {
        handleSegementSelect(segParam, true);
      } else {
        setSegments(travelSearchForm?.segments?.value);
      }
    }

    travelSearchForm?.segments?.value && travelSearchForm?.segments?.value.length > 0 && travelSearchForm?.segments?.value.forEach(item => {
      (0,XDMAnalytics.trackComponentView)({
        name: `${item.id.toLowerCase()}_segment_shown`,
        type: "plan"
      });

      if (item.isSelected) {
        (0,XDMAnalytics.trackComponentView)({
          name: `${item.id.toLowerCase()}_segment_selected`,
          type: "plan"
        });
      }
    });
  }, [travelSearchForm?.segments]);
  (0,react.useEffect)(() => {
    if (travelSearchForm.segments) {
      (0,XDMAnalytics.trackComponentView)({
        name: "special_segments_shown",
        type: "segment"
      });
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "special_segments_shown"
      }, "pageView", type);
    }
  }, [travelSearchForm.segments]);
  (0,react.useEffect)(() => {
    // Get query params from window.location.search (client-side) or use query prop (server-side compatible)
    let queryParams = query;

    if ( true && !queryParams) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      queryParams = {
        countries: urlSearchParams.get("countries") || undefined,
        startDate: urlSearchParams.get("startDate") || undefined,
        endDate: urlSearchParams.get("endDate") || undefined,
        segment: urlSearchParams.get("segment") || undefined
      };
    } // Process country data using the server-side compatible function


    const {
      countryData: totalCountryData,
      popularCountryData
    } = (0,static_utils/* processCountryDataFromQuery */.GZ)(value || [], queryParams, upcomingTrip, countryCode); // Update history if we're using upcoming trip country code (client-side only)

    if ( true && !queryParams?.countries && upcomingTrip?.countryCode) {
      (0,utils/* replaceHistory */.df)("countries", upcomingTrip.countryCode);
    }

    if (countryCode) {
      (0,utils/* replaceHistory */.df)("countries", countryCode);
    }

    setCountryData(totalCountryData);
    setShowCountry([...popularCountryData]);
    setPopularCountries([...popularCountryData]);
  }, [value, upcomingTrip, travelSearchForm.segments, query]);
  (0,react.useEffect)(() => {
    const button = buttonRef.current;
    let viewportMargin = 16;
    let searchBarOffset = 60;

    if (button) {
      const rect = button.getBoundingClientRect();
      const offsetTop = window.scrollY + rect.top;
      const isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        const scrollPosition = offsetTop - window.innerHeight + rect.height + viewportMargin + searchBarOffset;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth"
        });
      }
    }
  }, [showCountry]);

  const populateTravelDetails = (countryCodes, startDate, endDate, travellers) => {
    if (countryCodes) {
      (0,utils/* replaceHistory */.df)("countries", countryCodes);
    }

    if (startDate) {
      (0,utils/* replaceHistory */.df)("startDate", startDate);
    }

    if (endDate) {
      (0,utils/* replaceHistory */.df)("endDate", endDate);
    }

    if (travellers) {
      (0,utils/* replaceHistory */.df)("travellers", travellers);
    }
  };

  const viewOrdersClickHandle = () => {
    TravellingTo_analytics?.trackLandingEvents({
      actionType: "Ins_ViewAllOrdersClicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "Ins_ViewAllOrdersClicked"
      }
    });

    if (agentAgreementSection && !isConsented) {
      setShowAgreementModal(true);
      setAgreementSource("viewOrders");
    } else {
      goToViewOrders();
    }
  };

  const goToViewOrders = async () => {
    {
      const partner = (0,utils/* getPartnerOnClientSide */.et)();
      const requestData = {
        partner,
        query: {
          itineraryId: new URLSearchParams(window.location.search).get("itineraryId") || ""
        }
      };

      try {
        const response = await (0,api/* getOrdersMyPartner */.Ko)(requestData);
        const {
          responseStatus,
          nextPageRouteConfig
        } = response;

        if (responseStatus === src.RESPONSE_STATUS.SUCCESS) {
          if (nextPageRouteConfig?.type === "external_link") {
            window.open(nextPageRouteConfig?.route, "_blank");
          }
        }
      } catch (err) {
        console.error("GET ORDER MYPARTNER FAILURE ERROR ----", {
          err
        });
        const {
          error
        } = err?.response?.data || {};
        setNextPageError(error);
      }
    }
  };

  const handleUpcomingTripClick = () => {
    (0,utils/* replaceHistory */.df)("isUpcomingTrip", "true");
    (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
    TravellingTo_analytics?.trackLandingEvents({
      actionType: "upcoming_trips_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_trips_clicked"
      }
    });
    const {
      countryCode,
      travelDuration,
      travellerNum
    } = upcomingTrip || {};
    const selectedCountry = countryData?.find(country => country.code === countryCode);
    populateTravelDetails(selectedCountry?.code, travelDuration?.startDate?.toString(), travelDuration?.endDate?.toString(), travellerNum?.toString());
    const queryParams = new URLSearchParams(window.location.search);

    if (nextPageRoute) {
      let updatedNextPageRoute = nextPageRoute;

      if (updatedNextPageRoute.startsWith("/insurance")) {
        updatedNextPageRoute = updatedNextPageRoute.replace("/insurance", "");
      }

      navigation/* navigationActions.navigateToPageByRouteName */.ej.navigateToPageByRouteName(`${updatedNextPageRoute}&isUpcomingTrip=true`);
    } else {
      const data = {
        startDate: travelDuration?.startDate?.toString(),
        endDate: travelDuration?.endDate?.toString(),
        travellers: travellerNum?.toString?.(),
        countries: [countryCode],
        isUpcomingTrip: true,
        type: queryParams.get("type") || ""
      };
      navigation/* navigationActions.navigateToListing */.ej.navigateToListing(data);
    }
  };

  const handleShowOtherCountry = () => {
    if (!showOtherCountry) {
      let countryDataArr = countryData?.map(country => {
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: false,
          keywords: typeof country?.keywords === "string" ? country.keywords.split(",").map(keyword => keyword.trim()) : country?.keywords
        });
      });
      popularCountries.map(data => {
        countryDataArr = countryDataArr?.map(country => {
          if (country.code === data.code) {
            return _objectSpread(_objectSpread({}, country), {}, {
              isSelected: data.isSelected
            });
          }

          return _objectSpread({}, country);
        });
      });
      const isExclusiveCountrySelected = countryDataArr.find(item => item.isExclusiveSelection && item.isSelected);
      countryDataArr = countryDataArr.map(country => {
        if (isExclusiveCountrySelected) {
          return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
            isSelected: false,
            isDisabled: true
          });
        } else if (countryDataArr.some(item => item.isSelected)) {
          return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          }) : _objectSpread({}, country);
        }

        return _objectSpread({}, country);
      });
      const selectedRegionCodes = countryDataArr.filter(data => data.isSelected && data.type === "REGION").map(data => data.code);
      selectedRegionCodes?.map(code => {
        countryDataArr = countryDataArr.map(country => {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return _objectSpread(_objectSpread({}, country), {}, {
              isDisabled: true
            });
          }

          return _objectSpread({}, country);
        });
      });
      TravellingTo_analytics?.trackLandingEvents({
        actionType: `Ins_CountrySelected:OtherCountry`
      }, "pageView", type);
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "Ins_CountrySelected:OtherCountry"
        }
      });
      setCountryData(countryDataArr);
    }

    setOtherCountry(!showOtherCountry);
  };

  const handleDescriptionModal = country => {
    const clickedTime = (0,utility_src/* getSessionStorageItem */.St)("clickedTime") ? (0,utility_src/* getSessionStorageItem */.St)("clickedTime") : {};
    const currentTime = new Date().getTime();
    const code = country.code;

    if (!clickedTime[country.code] || currentTime - parseInt(clickedTime[country.code], 10) >= 1800000) {
      clickedTime[code] = currentTime.toString();
      (0,utility_src/* setSessionStorageItem */.D9)("clickedTime", _objectSpread({}, clickedTime));
      return country.description;
    }

    return "";
  };

  const handlePopularCountrySelect = code => {
    setIsCountryError(false);
    let popularCountryArr = popularCountries?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return _objectSpread({}, country);
        }

        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }

        TravellingTo_analytics?.trackLandingEvents({
          actionType: `Ins_CountrySelected:${country.name}`
        }, "pageView", type);
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return _objectSpread(_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const selectedCountries = popularCountryArr.filter(item => item.isSelected);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `Ins_CountrySelected`
      }
    }, {
      countries: selectedCountries // journeyType: "round_trip",

    });
    const isExclusiveCountrySelected = popularCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    popularCountryArr = popularCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return !country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        }) : _objectSpread({}, country);
      } else if (popularCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        }) : _objectSpread({}, country);
      }

      return _objectSpread({}, country);
    });
    const selectedPopRegionCodes = popularCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedPopRegionCodes.map(item => {
      popularCountryArr = popularCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return _objectSpread({}, country);
      });
    });
    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    const countries = popularCountryArr.filter(data => data.isSelected && !data.isDisabled).map(data => data.code).join(",");

    if (countries) {
      (0,utils/* replaceHistory */.df)("countries", countries);
    } else {
      (0,utils/* replaceHistoryRemoveParams */._A)("countries");
    }
  };

  const onConstentClick = async () => {
    const partner = (0,utils/* getPartnerOnClientSide */.et)();
    const requestData = {
      partner
    };

    try {
      const response = await (0,api/* hitRetailConsentMyPartner */.kk)(requestData);
      const {
        responseStatus
      } = response;

      if (responseStatus === src.RESPONSE_STATUS.SUCCESS) {
        setIsConsented(true);
        setShowAgreementModal(false);
        setIsConsented(true);
        TravellingTo_analytics?.trackLandingEvents({
          actionType: `Ins_DisclaimerAccepted`
        }, "pageView", type);
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_DisclaimerAccepted"
          }
        });
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_DisclaimerAccepted"
          }
        });

        if (agreementSource === "viewOrders") {
          goToViewOrders();
        } else {
          nextPageRouteCall();
        }
      }
    } catch (err) {
      console.error("HIT CONSENT MYPARTNER FAILURE ERROR ----", {
        err
      });
      const {
        error
      } = err?.response?.data || {};
      setNextPageError(error);
    }
  };

  const productOfferData = () => {
    if ( true && (productOfferBanner || domesticProductOfferBanner || internationalProductOfferBanner)) {
      const queryParams = new URLSearchParams(window.location.search);
      const selectedCountries = queryParams.get("countries");

      if (selectedCountries?.length) {
        if (isExclusiveCountrySelected) {
          return domesticProductOfferBanner || null;
        } else {
          return internationalProductOfferBanner || null;
        }
      } else {
        return productOfferBanner || null;
      }
    } else {
      return null;
    }
  };

  const handleSegementSelect = (segmentId, isOnRender) => {
    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map(item => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,utils/* replaceHistory */.df)("segment", item.id);
          TravellingTo_analytics?.trackLandingEvents({
            actionType: item.config.clickEventName
          }, "pageView", type);

          if (!isOnRender) {
            (0,XDMAnalytics.trackEvent)({
              event_detail: {
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: item.config.clickEventName
              }
            });
          }

          if (item?.calenderSelectionType === "SINGLE") {
            setLastCalendarTypeSingle(true);
          }
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  let toastTimeout = null;

  const toggleSegmentModal = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries?.split(",");

    if (!countryCodes) {
      setIsCountryError(true);
    } else if (countryCodes[0] == "IN" && segmentSelected?.id === "STUDENT") {
      setCountrySelectToastMsg("We do not have domestic student plans, please select another country to see student plans");
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => {
        setCountrySelectToastMsg("");
      }, 2000);
    } else {
      segmentSelected?.modal && setIsSegmentModalShown(true);
    }
  };

  const nextPageRouteCall = async () => {
    let searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries?.split(",");
    const selectedPopCountries = (popularCountries ?? []).filter(country => countryCodes?.includes(country.code)).map(item => item.name).join("|");
    TravellingTo_analytics?.trackLandingEvents({
      actionType: "popular_country_selected",
      payload: selectedPopCountries
    }, "pageView", type);
    TravellingTo_analytics?.trackLandingEvents({
      actionType: "explore_plan_click"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "explore_plan_click"
      }
    });

    if (calenderValue && countValue && countryCodes?.length) {
      const partner = (0,utils/* getPartnerOnClientSide */.et)();
      const requestData = {
        query: {
          itineraryId: searchParams.get("itineraryId") || "",
          type: type || "",
          source: travellerInfoSection ? "standalone_retail" : "standalone_regular"
        },
        partner,
        userSearchIntent: {
          country: countryCodes,
          departureDateTime: (0,static_utils/* convertDateToUnix */.cJ)(calenderValue.from),
          arrivalDateTime: calenderValue.to ? (0,static_utils/* convertDateToUnix */.cJ)(calenderValue.to) : Number(searchParams.get("endDate")),
          numberOfTravellers: countValue,
          segment: segmentSelected?.id,
          travellersData: travAgeRange?.map(item => {
            return {
              travellerAgeRange: {
                min: item?.value?.[0],
                max: item?.value?.[1]
              }
            };
          }),
          travellerDetails: {
            identifier: searchParams.get("bookingFor") || ""
          }
        }
      };
      const domain = partner === src.PARTNER.GI ? ".goibibo.com" : ".makemytrip.com";

      if (travellerInfoSection && !window?.mmt_android_bridge) {
        if ((0,utils/* getCookieByName */.A7)("next_page_req")) {
          document.cookie = `next_page_req=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/`;
        }

        document.cookie = `next_page_req=${JSON.stringify(requestData)}; expires=${new Date(Date.now() + 15 * 60 * 1000).toUTCString()}; domain=${domain}; path=/`;
        window.open(`/insurance/next-page`, "_blank");
      } else {
        try {
          const response = await (0,api/* getNextPageRouteDetails */.$P)(requestData);
          const {
            responseStatus,
            nextPageRouteConfig
          } = response;

          if (responseStatus === src.RESPONSE_STATUS.SUCCESS) {
            if (nextPageRouteConfig?.type === "external_link") {
              if (window?.mmt_android_bridge) {
                const link = document.createElement("a");
                link.href = `${nextPageRouteConfig?.route}&open=outside`;
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                window.open(nextPageRouteConfig?.route, "_blank");
              }
            } else {
              let route = nextPageRouteConfig?.route;

              if (route.startsWith("/insurance") && !location.pathname.includes("/travel-insurance")) {
                route = route.replace("/insurance", "");
              }

              navigation/* navigationActions.navigateToPageByRouteName */.ej.navigateToPageByRouteName(route);
            }
          }
        } catch (err) {
          console.error("NEXT PAGE ROUTE FAILURE ERROR ----", {
            err
          });
          const {
            error
          } = err?.response?.data || {};
          setNextPageError(error);
        }
      }
    }
  };

  const onSubmit = async () => {
    let searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const isUpcomingTrip = searchParams.get("isUpcomingTrip");
    const countryCodes = countries?.split(",");
    let retailAgeError = false;

    if (travellerInfoSection) {
      travAgeRange?.forEach(item => {
        if (!item.value || item.value.length !== 2) {
          setIsAgeRangeSelectedError(true);
          retailAgeError = true;
          return;
        }
      });
    }

    if (!countryCodes) {
      setIsCountryError(true);
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "error_shown",
        payload: error_message
      }, "pageView", type);
      (0,xdmEvents/* errorTrackEvent */.t1)({
        error_details_list: [{
          message: error_message,
          source: "country_select",
          severity: "P3"
        }]
      });
    }

    if (isUpcomingTrip) {
      (0,utils/* replaceHistoryRemoveParams */._A)("isUpcomingTrip");
      searchParams.delete("isUpcomingTrip");
      (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
    }

    (0,utils/* replaceHistory */.df)("segment", segmentSelected?.id);

    if (calenderValue && countValue && countryCodes?.length && !retailAgeError) {
      if (agentAgreementSection && !isConsented) {
        setShowAgreementModal(true);
        setAgreementSource("viewPlans");
      } else {
        (0,lib_analytics/* storePageTransitionStart */.SE)("landing");
        nextPageRouteCall();
      }
    }
  };

  if (nextPageError && true) {
    throw new utility_src/* ClientError */.XF(nextPageError);
  }

  const isExclusiveCountrySelected = popularCountries.find(item => item.isExclusiveSelection && item.isSelected);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyleWrap */.fK, {
    "data-test-id": "TravellingTo-TravellingToStyleWrap",
    children: [travelSearchBanner ? /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* DiscountingNote */.S_, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-DiscountingNote",
      children: [travelSearchBanner?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        width: "24px",
        height: "24px",
        src: travelSearchBanner?.icon,
        style: {
          animation: "rotate 2s linear infinite"
        },
        loading: "eager"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        flexDirection: device === "sm" ? "column" : "row",
        margin: "0px 0px 0px 4px",
        gap: device === "lg" ? "4px" : "0px",
        "data-test-id": "TravellingTo-FlexComp",
        children: [travelSearchBanner?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: travelSearchBanner?.title,
          baseStyle: {
            fontWeight: "bold",
            fontSize: device === "lg" ? "16px" : "12px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        }), travelSearchBanner?.description && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: travelSearchBanner?.description,
          baseStyle: {
            fontWeight: "regular",
            fontSize: device === "lg" ? "14px" : "12px",
            marginTop: device === "lg" ? "2px" : "0px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        })]
      })]
    }) : travelNote && travelNote.text && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TravelNote */.Me, {
      "data-test-id": "TravellingTo-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: travelNote,
        "data-test-id": "TravellingTo-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyle */.s0, {
      "data-test-id": "TravellingTo-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToCardStyle */.Fk, {
        ref: travellingToRef,
        "data-test-id": "TravellingTo-TravellingToCardStyle",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "TravellingTo-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
            color: Global/* theme.blackText */.rS.blackText,
            "data-test-id": "TravellingTo-H5Tag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: label,
              "data-test-id": "TravellingTo-FormattedText"
            })
          }), viewOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* ViewOrder */.C0, {
            onClick: viewOrdersClickHandle,
            "data-test-id": "TravellingTo-ViewOrder",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: viewOrders,
              "data-test-id": "TravellingTo-FormattedText"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          margin: "0px 0px 20px 0px",
          "data-test-id": "TravellingTo-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: placeHolder,
            baseStyle: {
              color: "#717171"
            },
            "data-test-id": "TravellingTo-FormattedText"
          })
        }), upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_UpcomingTrips, {
          country: upcomingTrip?.country,
          countryCode: upcomingTrip?.countryCode,
          travelDuration: upcomingTrip?.travelDuration,
          travellerNum: upcomingTrip?.travellerNum,
          travellerTitle: upcomingTrip?.travellerTitle,
          handleUpcomingTripClick: handleUpcomingTripClick,
          "data-test-id": "TravellingTo-UpcomingTrips"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          color: Global/* theme.greyText7 */.rS.greyText7,
          fontWeight: "bold",
          fontSize: "xs",
          margin: "2px 0 8px",
          "data-test-id": "TravellingTo-SpanTag",
          children: popularCountryTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: "Popular Destination",
            "data-test-id": "TravellingTo-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PopularCountryCompV2, {
          otherCountryTxt: otherCountryTxt,
          handleShowOtherCountry: handleShowOtherCountry,
          popCountry: showCountry,
          setIsSelectedError: setIsSelectedError,
          setCountrySelectToastMsg: setCountrySelectToastMsg,
          handlePopularCountrySelect: handlePopularCountrySelect,
          "data-test-id": "TravellingTo-PopularCountryComp"
        }), isCountryError && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          color: Global/* theme.redText2 */.rS.redText2,
          fontSize: "xs",
          margin: device === "sm" ? "0 0 8px" : "8px 0 0",
          "data-test-id": "TravellingTo-ParaTag",
          children: error_message
        }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
          margin: "14px -30px 14px",
          backgroundColor: "#FFFFFF",
          xs: true,
          "data-test-id": "TravellingTo-SectionDividers"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.TravellingToWidget, {
          travellerInfoSection: travellerInfoSection,
          travelPurposeTxt: travelPurposeTxt,
          travCountTitle: travCountTitle,
          travCountSubtitle: travCountSubtitle,
          travCountLimit: travCountLimit,
          travPurpTitle: travPurpTitle,
          travDateTitle: travDateTitle,
          btnDisabledState: btnDisabledState,
          countValue: countValue,
          setCountValue: setCountValue,
          travAgeRange: travAgeRange,
          setTravAgeRange: setTravAgeRange,
          calendarDatesLimit: calendarDatesLimit,
          setCalenderValue: setCalenderValue,
          setIsAgeRangeSelectedError: setIsAgeRangeSelectedError,
          upcomingTravellerNum: upcomingTrip?.travellerNum,
          upcomingFromDate: upcomingTrip?.travelDuration?.startDate,
          upcomingToDate: upcomingTrip?.travelDuration?.endDate,
          lastCalendarTypeSingle: lastCalendarTypeSingle,
          query: query,
          selectedSegment: segmentSelected && Object.keys(segmentSelected).length > 0 ? segmentSelected : preSelectedSegment,
          calendarConfig: isExclusiveCountrySelected?.config?.calendar || segmentSelected?.config || preSelectedSegment?.config || calendarDatesLimit,
          travellingToRef: travellingToRef,
          travellerBookingFor: travellerBookingFor,
          travCounterTitle: travCounterTitle,
          "data-test-id": "TravellingTo-TravellingToWidget"
        }), travellerInfoSection && isAgeRangeSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
          justifyContent: device === "sm" ? "flex-start" : "right",
          margin: "-22px 0px 24px 0px",
          "data-test-id": "TravellingTo-FlexComp",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "xs",
            color: "#EB2026",
            "data-test-id": "TravellingTo-SpanTag",
            children: travellerInfoSection?.selectError ?? "Please select age ranges and number of travellers"
          })
        }), productOfferData() && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          justifyContent: "space-between",
          alignItems: "center",
          bgColor: "#EFF1FF",
          borderRadius: "8px",
          padding: "5px 4px",
          margin: "0 0 24px",
          "data-test-id": "TravellingTo-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "4px",
            "data-test-id": "TravellingTo-FlexComp",
            children: [productOfferData()?.icon ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: productOfferData()?.icon,
              width: 24,
              height: 24
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                width: "4px"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: productOfferData()?.title,
              "data-test-id": "TravellingTo-FormattedText"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
            alignItems: "flex-end",
            "data-test-id": "TravellingTo-FlexComp",
            children: productOfferData()?.info?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: productOfferData()?.info?.icon,
              width: 24,
              height: 24,
              onClick: () => {
                window.open(productOfferData()?.info?.url, "_blank");
              }
            })
          })]
        }), travelSearchForm?.segments && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          margin: "0 0 24px",
          gap: "8px",
          flexDirection: "column",
          "data-test-id": "TravellingTo-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            fontSize: "xs",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "TravellingTo-ParaTag",
            children: travelSearchForm?.segments?.label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.Tags, {
            handleClickTab: handleSegementSelect,
            data: travelSearchForm?.segments?.value,
            "data-test-id": "TravellingTo-Tags"
          })]
        }), isSegmentModalShown && segmentSelected && segmentSelected?.modal && /*#__PURE__*/(0,jsx_runtime.jsx)(SegmentModal["default"], {
          modal: segmentSelected.modal,
          onClose: () => setIsSegmentModalShown(false),
          onPrimaryCta: onSubmit,
          onSecondaryCta: () => setIsSegmentModalShown(false),
          "data-test-id": "TravellingTo-SegmentModal"
        }), travelBtnTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
          buttonref: buttonRef,
          customWidth: "100%",
          customTitle: travelBtnTxt,
          onClick: segmentSelected?.modal && travelSearchForm?.segments ? toggleSegmentModal : onSubmit,
          "data-test-id": "TravellingTo-LandingButton"
        }), travelSearchForm?.disclaimer && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          color: Global/* theme.greyText */.rS.greyText,
          margin: "16px 0 0",
          "data-test-id": "TravellingTo-ParaTag",
          children: travelSearchForm.disclaimer
        })]
      }), footerSection && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FooterSectionComp, {
        icon: footerSection.icon,
        description: footerSection.description,
        background: footerSection.background,
        border: footerSection.border,
        tooltip: footerSection.tooltip,
        "data-test-id": "TravellingTo-FooterSectionComp"
      }), agentAgreementSection && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AgentAgreementModal, {
        agentAgreementData: agentAgreementSection,
        showAgreementModal: showAgreementModal,
        setShowAgreementModal: setShowAgreementModal,
        onConstentClick: onConstentClick,
        "data-test-id": "TravellingTo-AgentAgreementModal"
      }), showOtherCountry && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SelectCountryModalV2, {
        countryData: countryData,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        showCountry: showCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModalV2"
      }), showOtherCountry && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SelectCountryModalSheetV2, {
        countryData: countryData,
        showCountry: showCountry,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModalSheetV2"
      }), descriptionTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionModal/* default */.Z, {
        handleDescriptionModal: () => setDescriptionTxt(""),
        value: descriptionTxt,
        title: descTitle,
        "data-test-id": "TravellingTo-DescriptionModal"
      }), isSelectedError && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      }), isSelectedError && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "10px",
        "data-test-id": "TravellingTo-WebToast"
      }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
        toastTxt: countrySelectToastMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      })]
    })]
  });
};

/* harmony default export */ const TravelDetails_TravellingTo = (TravellingTo);

/***/ }),

/***/ 89391:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87109);
/* harmony import */ var _TravellingToWidget_TravellingToWidgetShimmer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16638);
/* harmony import */ var _Shimmer_ShimmerVersion2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6456);
/* harmony import */ var _Shimmer_ShimmerVersion3__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20863);
/* harmony import */ var _TravelDetails_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25941);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52322);










const TravellingToShimmer = () => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_TravelDetails_style__WEBPACK_IMPORTED_MODULE_6__/* .TravellingToStyleWrap */ .fK, {
    "data-test-id": "TravellingToShimmer-TravellingToStyleWrap",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_TravelDetails_style__WEBPACK_IMPORTED_MODULE_6__/* .TravelNote */ .Me, {
      "data-test-id": "TravellingToShimmer-TravelNote",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Shimmer_ShimmerVersion3__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        height: "22px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_TravelDetails_style__WEBPACK_IMPORTED_MODULE_6__/* .TravellingToStyle */ .s0, {
      "data-test-id": "TravellingToShimmer-TravellingToStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Shimmer_ShimmerVersion2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        margin: "0 0 16px",
        width: "100%",
        height: "28px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Shimmer_ShimmerVersion2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        margin: "0 0 8px",
        width: "80%",
        height: "16px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        margin: device == "sm" ? "0 0 20px" : "",
        flexWrap: "wrap",
        gap: "8px",
        "data-test-id": "TravellingToShimmer-FlexComp",
        children: Array.from({
          length: 5
        }, (_, index) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Shimmer_ShimmerVersion2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          width: "89px",
          height: "79px",
          "data-test-id": `TravellingToShimmer-ShimmerVersion2-${index}`
        }, index))
      }), device == "lg" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SectionDividers, {
        margin: "30px -30px 30px",
        xs: true,
        "data-test-id": "TravellingToShimmer-SectionDividers"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_TravellingToWidget_TravellingToWidgetShimmer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        "data-test-id": "TravellingToShimmer-TravellingToWidgetShimmer"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Shimmer_ShimmerVersion3__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        width: "100%",
        height: "44px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TravellingToShimmer);

/***/ }),

/***/ 16641:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TravelPlexBot_TravelPlexBot)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/travelFlexConfig.tsx
var travelFlexConfig = __webpack_require__(90758);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelPlexBot/TravelPlexBot.style.ts

const TravelPlexBotWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelPlexBotstyle__TravelPlexBotWrapper",
  componentId: "e1nbco-0"
})(["& .myraFloatingBar{bottom:100px !important;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelPlexBot/TravelPlexBot.tsx




 // Import the actual TravelPlexBot implementation


const TravelplexBotIcon = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.t.bind(__webpack_require__, 97809, 23)), {
  ssr: false,
  // This ensures the component only loads on client side
  loading: () => null // No loading component
  ,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(97809)]
  }
});

const TravelPlexBot = ({
  view
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: isClient,
    1: setIsClient
  } = (0,react.useState)(false);
  const {
    0: showPersuasions,
    1: setShowPersuasions
  } = (0,react.useState)(true);
  const {
    0: isAnimating,
    1: setIsAnimating
  } = (0,react.useState)(false);
  const chatConfig = (0,travelFlexConfig/* generateChatConfigFromURL */.Ys)(view || "LANDING");
  (0,react.useEffect)(() => {
    setIsClient(true);
  }, []);
  (0,react.useEffect)(() => {
    const timer = setTimeout(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setShowPersuasions(false);
        setIsAnimating(false);
      }, 500);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleGetMetaDataMessage = () => {
    // Navigate to the appropriate section in your app
    const iframe = document.getElementById("myra-assistive-app");

    if (iframe && iframe?.contentWindow) {
      iframe?.contentWindow?.postMessage({
        type: "CHAT_BOT__GET_META_DATA",
        payload: JSON.stringify({
          chatConfig
        })
      }, "*");
    }
  };

  const persusasions = [{
    html: `
        <div style='
          line-height: 14px; 
          font-family: Lato; 
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); 
          opacity: ${isAnimating ? "0" : "1"}; 
          transform: ${isAnimating ? "translateY(-15px) scale(0.95)" : "translateY(0) scale(1)"};
          filter: ${isAnimating ? "blur(1px)" : "blur(0px)"};
        '>
          <span style='color:#000; font-size:16px;font-weight:400;'>Hey </span>
          <span style='
            background-image: linear-gradient(to left, #824BC4, #5735B8); 
            background-clip: text; 
            -webkit-text-fill-color: transparent;
            font-size:18px;
            font-weight:900;
            line-height:20px;
          '>
            <b>I am Myra</b>
          </span>
        </div>
      `
  }]; // Only render on client side

  if (!isClient) {
    return null;
  }

  const params = {
    key: "value1"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TravelPlexBotWrapper, {
    "data-test-id": "TravelPlexBot-TravelPlexBotWrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TravelplexBotIcon, {
      trackingData: {
        pdtTrackingData: {},
        omnitureTrackingData: {}
      },
      lob: "Insurance",
      platform: device === "lg" ? "desktop" : "pwa",
      shouldDoCenterAnimation: true,
      shouldAlwaysDoTextScrollAnimation: true,
      persuasions: showPersuasions ? persusasions : [],
      onBotGetMetaDataEvent: handleGetMetaDataMessage // onBotEvent={handleBotEvent}
      ,
      params: params,
      "data-test-id": "TravelPlexBot-TravelplexBotIcon"
    })
  });
};

/* harmony default export */ const TravelPlexBot_TravelPlexBot = (TravelPlexBot);

/***/ })

}]);